// @ts-nocheck
import * as React from "react";

const AdhesiveCaulks: React.FC = () => {
    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 47 47"
            enableBackground="new 0 0 47 47;"
        >
            <g id="Calque_3">
                <g>
                    <path
                        id="Fill-5"
                        fill="#ffffff"
                        d="M45.5,23.5c0,12.2-9.9,22-22,22c-12.2,0-22-9.9-22-22c0-12.2,9.9-22,22-22
			C35.7,1.5,45.5,11.3,45.5,23.5"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        fill="#1D1D1B"
                        d="M31.5,3l0.5,7.1c0,0,0,2.3,0,3c0,0.6,0,3.7,0,3.7s-0.1,0.9-1.5,0.9c-1.4,0-1.3-0.9-1.3-0.9l0.2-6.8l1-7.2
			c-2.1-0.7-4.4-1.1-6.8-1.1c-12.2,0-22,9.8-22,22c0,8.7,5.1,16.2,12.4,19.8l-0.7-8.5c0,0,1.1,2.2,5,2.2c4.1-0.1,4.6-2.4,4.6-2.4
			l0,10.9c0.2,0,0.4,0,0.7,0c0.1,0,0.1,0,0.2,0L24,20c0,0,1.4,3,6.6,3.2c5.4,0.2,6.2-3,6.2-3L35.4,42c6.1-3.9,10.1-10.7,10.1-18.5
			C45.5,14.2,39.7,6.2,31.5,3z M17.5,20.2c0,0,0-0.3,0.2-0.3c0.2,0,0.3,0.3,0.3,0.3l0.8,6.9c0,0,0.1,1.8,0.1,2.2
			c0,0.5,0.1,2.8,0.1,2.8s0,0.7-1.1,0.7c-1,0-1-0.6-1-0.6L16.9,27L17.5,20.2z M23,33.2c0,0-0.6,2.6-4.6,3c-2.6,0.2-4.3-1.2-4.6-1.5
			c-0.7-0.7-0.8-1.4-0.8-1.4L13,32.1c0,0,0-1.1,0.9-2c1-0.9,2-1.1,2-1.1l0.2,3.3c0,0,0,1.5,2,1.4c2-0.1,1.9-1.7,1.9-1.7l-0.2-3.1
			c0,0,2.5,0.5,3,2.4C23.1,32.2,23,33.2,23,33.2z M37.1,18.3c0,0-0.9,3.4-6.2,3.7c-3.4,0.2-5.6-1.8-6-2.3c-0.8-1-0.9-1.9-0.9-1.9
			l-0.1-1.4c0,0,0-1.4,1.4-2.5c1.3-1.1,2.7-1.4,2.7-1.4l0,4.4c0,0-0.1,2,2.6,1.9c2.7-0.1,2.7-2.2,2.7-2.2l-0.1-4.1
			c0,0,3.3,0.8,3.9,3.4C37.3,17,37.1,18.3,37.1,18.3z"
                    />
                </g>
            </g>
        </svg>
    );
};

export default React.memo(AdhesiveCaulks);
